import React from 'react';
import {
  Header,
  Footer
} from '../containers';

/**
 * 登录组件
 */
export default class Login extends React.Component {
  constructor(props){
    super(props)
    document.title = "关于我们"
    this.state = {
      text: 'Loading...'
    }
  }

  render() {
    return (
      <div>
        <Header/>
        {this.state.text}
        <Footer/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Login.js